<template>
  <v-card class="elevation-0 ma-8 px-2 py-6">
    <v-card-title>
        Planes de Entrenamiento
        <v-spacer></v-spacer>
        <!--v-text-field
            hide-default-footer
            @keydown.enter="getDataFromApi()"
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
            class="mb-6 mx-4"
        ></v-text-field-->
    </v-card-title>
    
    <v-data-table
        show-expand
        :items="training_plans" 
        :headers="header"
        :footer-props="{'items-per-page-options':[15, 30, 50, totalTrainingPlans]}"
       :options.sync="options"
        :server-items-length="totalTrainingPlans"
        :loading="loading"
        class="px-6"
    ><!-- :options.sync="options"-->
        <!--template v-slot:[`item.name`]="{ item }">
            {{item.name!=null?item.name:('Plan de ' + item.user.name)}}
        </template-->
        <template v-slot:[`item.muscular_groups`]="{ item }">
            <v-chip small class="ma-2" v-for="(muscular_group, index) in item.details?.map(d=>d.muscular_groups)" :key="index">{{muscular_group}}</v-chip>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
                <v-data-table
                    hide-default-footer
                    show-expand
                    :items="item.details" 
                    :headers="[
                        {text:'Titulo', value:'title'},
                        {text:'Categoría(s)', value:'muscular_groups'},
                    ]"
                    class="pa-6"
                    style="background:transparent;"
                >
                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                            <v-data-table
                                hide-default-footer
                                :items="item.exercises" 
                                :headers="[
                                    {text:'Ejercicio', value:'title'},
                                    {text:'Categoría(s)', value:'categories'},
                                    {text:'Dificultad', value:'difficulty'},
                                    {text:'Series/Reps', value:'sr'},
                                ]"
                                class="pa-6"
                                style="background:transparent;"
                            >
                                <template v-slot:[`item.categories`]="{ item }">
                                    <v-chip v-for="(category, index) in item.categories" :key="index" small class="mr-2">{{category.name}}</v-chip>
                                </template>
                                <template v-slot:[`item.sr`]="{ item }">
                                    {{item.additional_data.series}} / {{item.additional_data.reps}}
                                </template>
                            </v-data-table>
                        </td>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-menu bottom right>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list style="font-size:13px;">
                                <v-list-item @click="edited_item = item, editDialog = true">
                                    <v-icon small class="mr-2">
                                        mdi-pencil
                                    </v-icon>
                                    Editar
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                </v-data-table>
            </td>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
            <v-menu bottom right>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>
                <v-list style="font-size:13px;">
                    <v-list-item @click="edited_item = item, editDialog = true">
                        <v-icon small class="mr-2">
                            mdi-pencil
                        </v-icon>
                        Editar
                    </v-list-item>
                </v-list>
                <v-list style="font-size:13px;">
                    <v-list-item @click="edited_item = item, confirm_delete = true">
                        <v-icon small class="mr-2">
                            mdi-delete
                        </v-icon>
                        Eliminar
                    </v-list-item>
                </v-list>
            </v-menu>
        </template>
    </v-data-table>
    <v-snackbar :color="snackbar.color" v-model="snackbar.show">
        {{ snackbar.message }}
    </v-snackbar>
    <!-- Crear alimento -->
    <v-dialog fullscreen v-model="createDialog">
        <template v-slot:activator="{ on, attrs }">
            <v-btn bottom color="#e12826" dark fab fixed right v-bind="attrs" v-on="on">
                <v-icon color="white">  mdi-plus </v-icon>
            </v-btn> 
        </template>
        <div>
            <v-toolbar dark color="#e12826" >
                <v-spacer></v-spacer>
                <v-btn icon dark @click="createDialog=false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card>
                <create @closeCreateDialog="closeCreateDialog"/>
            </v-card>
        </div>
    </v-dialog>
    <!-- editar alimento -->
    <v-dialog v-model="editDialog" max-width="700px">
      <edit v-bind:training_plan="edited_item" @closeEditDialog="closeEditDialog"/>
    </v-dialog>

    
    <div class="text-center">
      <v-bottom-sheet  v-model="confirm_delete" inset>
        <v-sheet class="text-center" height="150px">
          <div class="pt-6">
          ¿Seguro que deseas borrar el plan de entrenamiento <strong>{{edited_item.name}}</strong>? Todos los pacientes que lo tengan asignado lo perderan
          </div>
          <v-btn class="mt-4" text color="error" @click="deleteTrainingPlan()">
          Eliminar
          </v-btn>
          <v-btn class="mt-4" text color="grey" @click="edited_item={}, confirm_delete=false">
          Cancelar
          </v-btn>
        </v-sheet>
      </v-bottom-sheet>
    </div>
  </v-card>
</template>

<script>
import Create from './create.vue'
import Edit from './edit.vue'
import axios from "axios"
  export default {
    components:{
      'create': Create,
      'edit':Edit
    },
    data () {
      return {
        confirm_delete:false,
        edited_item:{},
        editDialog:false,
        createDialog:false,
        editDialog: false,
        totalTrainingPlans: 0,
        training_plans: [],
        loading: true,
        options: {},
        activeSearch: false,
        search: '',
        header: [
            { text: '', value: 'data-table-expand' },
            {text:'Plan', value:'name'},
            //{text:'Categorias', value:'muscular_groups'},
            {text:'Bloques', value:'bloques'}
        ],
        snackbar: {
            show: false,
            message: null,
            color: null
        },
      }
    },
    watch: {
        options: {
            handler () {
                this.getDataFromApi()
            },
            deep: true,
        },
        currentUser: {
            handler () {
                this.getDataFromApi()
            },
            deep: true,
        },
    },
    methods:{
        deleteDish(){
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/workout_routines/" + this.edited_item.id).then(response => {
                this.confirm_delete = false
                this.edited_item = undefined
                this.getDataFromApi()
            })
        },
        getDataFromApi () {
            this.loading = true
            this.apiCall().then(data => {
                this.training_plans = data.training_plans
                this.totalTrainingPlans = data.total
                this.loading = false
            })
        },
        apiCall () {
            return new Promise((resolve, reject) => {
                const { sortBy, sortDesc, page, itemsPerPage } = this.options
                var training_plans = []
                var total = 0
                var link = ''
                if(sortBy.length === 1){
                    if(sortDesc[0]){
                        link = link + "sort=-" + sortBy[0] + '&'
                    }else{
                        link = link + "sort=" + sortBy[0] + '&'
                    }
                }
                if(this.search!=''){
                    link = link + 'filter[name]=' + this.search + '&'
                }
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/workout_routines?" + link + "page=" + page + "&itemsPerPage=" + itemsPerPage + "&filter[user_id]=" + this.currentUser.id).then(response => {
                    const resp = response.data
                    training_plans = this.mapTrainingPlans(resp)
                    total = training_plans.length//.meta.total
                    resolve({
                        training_plans,
                        total,
                    })
                })
            })
        },
        mapTrainingPlans(items){
            return items.data.filter(id=>id.user==null).sort((a, b) => b.id - a.id)
        },
        closeCreateDialog: function(params){
            this.getDataFromApi()
            this.createDialog = params
        },
        closeEditDialog: function(params){
            this.getDataFromApi()
            this.editDialog = params
        }
    },
    computed:{
      currentUser:{
        get(){
          return this.$store.state.currentUser.user;
        }
      },
    }
}
</script>

<style >
    .flex-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    }
    .v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
        box-shadow: none!important;
        background: #eeeeee75;
    }
</style>